import { gql } from "@apollo/client";

export const CompetitorAnalysisState = {
  productCode: "",
  productName: "",
  productBrand: "",
  productCategory: "",
  competitorPrice: "",
  productImage: null,

  productCodeStatus: "unchecked",
  productNameStatus: "unchecked",
  productBrandStatus: "unchecked",
  productCategoryStatus: "unchecked",
  competitorPriceStatus: "unchecked",
  productImageStatus: false,
};

export const CompetitorAnalysisStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "productCode": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productCode: value,
          productCodeStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCode: "",
          productCodeStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productCode: value,
          productCodeStatus: "error",
        };
      }
    }
    case "productName": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productName: value,
          productNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productName: "",
          productNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productName: value,
          productNameStatus: "error",
        };
      }
    }
    case "productBrand": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productBrand: value,
          productBrandStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productBrand: "",
          productBrandStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productBrand: value,
          productBrandStatus: "error",
        };
      }
    }
    case "productCategory": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          productCategory: value,
          productCategoryStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          productCategory: "",
          productCategoryStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          productCategory: value,
          productCategoryStatus: "error",
        };
      }
    }
    case "competitorPrice": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          competitorPrice: value,
          competitorPriceStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          competitorPrice: "",
          competitorPriceStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          competitorPrice: value,
          competitorPriceStatus: "error",
        };
      }
    }
    case "productImage": {
      if (value) {
        return {
          ...state,
          productImage: value,
          productImageStatus: true,
        };
      } else if (!value) {
        return {
          ...state,
          productImage: null,
          productImageStatus: false,
        };
      }
    }

    default:
      return state;
  }
};

// datefilter State store

export const dateFilter = {
  formDate: null,
  endDate: null,

  formDateStatus: "",
  endDateStatus: "",
};

// datefilter State Onchange Mange

export const dateFilterMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "formDate": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          formDate: value,
          formDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          formDate: "",
          formDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          formDate: "",
          formDateStatus: "error",
        };
      }
    }
    case "endDate": {
      const alphaNLenghthRegex = new RegExp("^.{1,100}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          endDate: value,
          endDateStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          endDate: "",
          endDateStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          endDate: "",
          endDateStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};

export const createCompetitorProduct = gql`
  mutation CreateCompetitorProduct($input: CreateCompetitorProductInput!) {
    createCompetitorProduct(input: $input) {
      success
      error
      message
    }
  }
`;
export const updateCompetitorProduct = gql`
  mutation UpdateCompetitorProduct($input: UpdateCompetitorProductInput!) {
    updateCompetitorProduct(input: $input) {
      success
      error
      message
    }
  }
`;

export const getAllCompetitorProducts = gql`
  query GetAllCompetitorProducts(
    $page: Int
    $pageSize: Int
    $filters: CompetitorProductFilterInput
  ) {
    getAllCompetitorProducts(
      page: $page
      pageSize: $pageSize
      filters: $filters
    ) {
      success
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        productCode
        productName
        productBrand
        competitorPrice
        agentName
        productImageUrl
        status
        createdAt
        createdBy {
          employeeName
        }
      }
    }
  }
`;

export const getCompetitorProductById = gql`
  query GetCompetitorProductById($id: Int!) {
    getCompetitorProductById(id: $id) {
      success
      error
      message
      data {
        id
        productCode
        productName
        productBrand
        productCategory
        productImage
        createdAt
        competitorPrice
      }
    }
  }
`;

export const exportCompetitorProducts = gql`
  mutation ExportCompetitorProducts($filters: CompetitorProductFilterInput) {
    exportCompetitorProducts(filters: $filters) {
      success
      error
      message
      downloadUrl
    }
  }
`;

export const uploadCompetitorProducts = gql`
  mutation uploadCompetitorProducts($file: Upload!, $userId: Int!) {
    uploadCompetitorProducts(file: $file, userId: $userId) {
      success
      error
      message
    }
  }
`;

export const deleteCompetitorProduct = gql`
  mutation DeleteCompetitorProduct($productId: ID!) {
    deleteCompetitorProduct(productId: $productId) {
      success
      error
      message
    }
  }
`;
